import axios from '../requester';
import { API } from '../constants/api-urls';

export const getIssuePossibleStates = async ({ id }) =>
  axios
    .get(`${API.ISSUES_PATH}/${id}/states`)
    .then(({ current, available_states }) => ({ current, available_states }));

export const patchIssueState = async ({ id, state_name, state_id }) =>
  axios.patch(`${API.ISSUES_PATH}/${id}/provider-state`, {
    state_name,
    state_id
  });

export const getPredictedIssuesCount = async payload =>
  axios.post(`${API.ISSUES_PATH}/count`, payload);
